import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

const components = {
  h1: ({ children }) => (
    <h1 className="text-2xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-4">{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">{children}</h3>
  ),
  p: ({ children }) => (
    <p className="text-gray-700 leading-relaxed mb-3">{children}</p>
  ),
  li: ({ children }) => (
    <li className="text-gray-700">{children}</li>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold text-gray-900">{children}</strong>
  ),
  a: ({ children, href }) => (
    <a href={href} className="text-blue-600 underline">{children}</a>
  ),
  blockquote: ({ children }) => (
    <blockquote className="border-l-4 border-gray-300 pl-4 italic text-gray-600 my-4">{children}</blockquote>
  ),
  code: ({ children, className: codeClassName }) => {
    // Inline code vs code blocks
    if (codeClassName) {
      return <code className={`${codeClassName} text-gray-800`}>{children}</code>
    }
    return <code className="bg-gray-100 text-gray-800 px-1.5 py-0.5 rounded text-sm">{children}</code>
  },
  table: ({ children }) => (
    <div className="overflow-x-auto my-4">
      <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
        {children}
      </table>
    </div>
  ),
  th: ({ children }) => (
    <th className="bg-gray-100 px-4 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider border-b border-gray-200">
      {children}
    </th>
  ),
  td: ({ children }) => (
    <td className="px-4 py-2 text-sm text-gray-700 border-b border-gray-100">
      {children}
    </td>
  ),
}

function PolicyPreview({ content, title, className = '', id }) {
  return (
    <div
      id={id}
      className={`bg-white text-gray-900 rounded-lg p-8 ${className}`}
      style={{ colorScheme: 'light' }}
    >
      {title && (
        <h1 className="text-2xl font-bold text-gray-900 border-b border-gray-200 pb-3 mb-6">{title}</h1>
      )}
      <div className="prose prose-sm prose-gray max-w-none">
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
          {content || ''}
        </ReactMarkdown>
      </div>
    </div>
  )
}

export default PolicyPreview
